// extracted by LIB_CSS_EXTRACT_LOADER
import "./badge_module.css"
export default {"badge":"badge-OKfNya","default":"default-ycSfOg","secondary":"secondary-QFt0yY","destructive":"destructive-KIA3qI","outline":"outline-AXvlm0"};